<template>
  <div class="vet-passport-form__container">
    <FormTitle title="Заповніть дані про ветеринарний паспорт" />
    <div class="vet-passport-form__fields">
      <div class="vet-passport-form__field-row">
        <TextInput
          class="vet-passport-form__field"
          placeholder="Серія *"
          :limit="14"
          v-model="vetPassport.serial"
          :error-messages="getValidationErrors('vetPassport.serial', {
            required: 'Введіть серію паспорта',
          })"
          @change="$emit('changeVetPassportSerial', $event)"
          @blur="touchField('vetPassport.serial')"
        />
        <TextInput
          class="vet-passport-form__field"
          placeholder="Номер *"
          :limit="9"
          v-model="vetPassport.number"
          :error-messages="getValidationErrors('vetPassport.number', {
            required: 'Введіть номер паспорта',
          })"
          @change="$emit('changeVetPassportNumber', $event)"
          @blur="touchField('vetPassport.number')"
        />
      </div>
      <div class="vet-passport-form__field-row">
        <DateInput
          class="vet-passport-form__field"
          placeholder="Дата видачі *"
          format="DD.MM.YYYY"
          type="input"
          v-model="vetPassport.date"
          :error-messages="getValidationErrors('vetPassport.date', {
            required: 'Введіть дату видачі',
          })"
          @change="$emit('changeVetPassportDate', $event)"
          @blur="touchField('vetPassport.date')"
        />
        <TextInput
          class="vet-passport-form__field"
          placeholder="Ким виданий *"
          :limit="100"
          v-model="vetPassport.issuedBy"
          :error-messages="getValidationErrors('vetPassport.issuedBy', {
            required: 'Введіть орган, що видав паспорт',
          })"
          @change="$emit('changeVetPassportIssuedBy', $event)"
          @blur="touchField('vetPassport.issuedBy')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { ValidateForm } from '@/shared/lib/form';
import { DateInput, FormTitle, TextInput } from '@/shared/ui/form';

export default {
  props: {
    vetPassportSerial: {
      type: String,
      default: null,
    },
    vetPassportNumber: {
      type: String,
      default: null,
    },
    vetPassportDate: {
      type: [String, Date],
      default: null,
    },
    vetPassportIssuedBy: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      vetPassport: {
        serial: this.vetPassportSerial,
        number: this.vetPassportNumber,
        date: this.vetPassportDate,
        issuedBy: this.vetPassportIssuedBy,
      },
    };
  },
  validations() {
    return {
      vetPassport: {
        serial: { required },
        number: { required },
        date: { required },
        issuedBy: { required },
      },
    };
  },
  mixins: [ValidateForm],
  components: { FormTitle, TextInput, DateInput },
  watch: {
    vetPassportSerial(newValue) {
      this.vetPassport.serial = newValue;
    },
    vetPassportNumber(newValue) {
      this.vetPassport.number = newValue;
    },
    vetPassportDate(newValue) {
      this.vetPassport.date = newValue;
    },
    vetPassportIssuedBy(newValue) {
      this.vetPassport.issuedBy = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.vet-passport-form {
  &__container {
    margin-bottom: 24px;
  }
  &__fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  &__field-row {
    display: flex;
    gap: 24px;
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
  }
  &__field {
    flex: 1;
  }
}
</style>